/** @format */

import {CrudRequest} from "@crud/core";

export class CrudFactory extends CrudRequest {
    //online url

    baseUrl = "https://services4home.in/api/";
    baseUrl2 = "https://services4home.in/uploads/";
    websocketUrl = "wss://services4home.in";

    dateFormat = "MMMM Do YYYY hh:mm A";

    // test url
    // baseUrl = "http://localhost:7000/api/";
    // baseUrl2 = "http://localhost:7000/uploads/";
    // websocketUrl = "ws://d0d2-2401-4900-1c62-747-b079-b1a-e069-28ff.in.ngrok.io";

    //localhost url

    // baseUrl = "https://18a8-2401-4900-1c62-db85-cc55-cae7-eedb-16a0.in.ngrok.io/api/";
    // baseUrl2 = "https://18a8-2401-4900-1c62-db85-cc55-cae7-eedb-16a0.in.ngrok.io/uploads/";
    // websocketUrl = "wss://18a8-2401-4900-1c62-db85-cc55-cae7-eedb-16a0.in.ngrok.io";

    getUrl = (...segments) =>
        segments.reduce((url, segment) => url + segment, this.baseUrl);

    async get(url, data = {}, requestOptions = {}) {
        return this.send({
            method: "GET",
            url,
            data,
            ...requestOptions,
        });
    }

    async post(url, data = {}, requestOptions = {}) {
        return this.send({
            method: "POST",
            url,
            data,
            ...requestOptions,
        });
    }

    async delete(url, data = {}, requestOptions = {}) {
        return this.send({
            method: "DELETE",
            url,
            data,
            ...requestOptions,
        });
    }

    async send(requestOptions = {}) {
        const {url, data, method, notify = true} = requestOptions;

        const options = {
            ...requestOptions.ajaxOptions,
            method,
        };

        let fullUrl;

        options.headers = {
            ...options.headers,
            Accept: "application/json",
            Authorization: localStorage.getItem("login_token"),
        };

        if (!(data instanceof FormData)) {
            options.headers["Content-Type"] = "application/json";
        }

        fullUrl = this.getUrl(url);

        if (options.method === "GET") {
            const queryString = new URLSearchParams(data);
            fullUrl += `?${queryString}`;
        } else if (data instanceof FormData) {
            options.body = data;
        } else {
            options.body = JSON.stringify(data);
        }

        let res = {
            data: [],
            message: "",
            type: "error",
            errors: [],
        };

        try {
            this.call("loading", [true]);
            const response = await fetch(fullUrl, options);
            if (response.status === 200) {
                res = await response.json();
                const {type, message} = res;
                if (options.method !== "GET" && notify) {
                    this.notify({
                        message,
                        type,
                    });
                }
            } else {
                // no inspection ExceptionCaughtLocallyJS
                throw new Error(`${response.status} : ${response.statusText}`);
            }
        } catch (e) {
            this.call("loading", [false]);
            console.error(e);
            this.notify({
                message: e.message,
                type: "error",
            });
            throw e;
        } finally {
            this.call("loading", [false]);
        }

        const {type} = res;

        if (type === "error") throw res;

        return res;
    }
}

export const crud = new CrudFactory();
